export default __webpack_public_path__ + "locales/zh-CN/ConvertDialog.json?hash=5e022e4cde12d1e2ad61b0db652b7e1f";